export enum CONNECTED_BOX_PROVIDERS {
  ACSES = "ACSES",
  SNAPACCESS = "SNAPACCESS",
}
